<div class="container-fluid bg-black text-light d-flex justify-content-between d-none d-lg-flex">
    <nav class="container px-1 d-flex justify-content-between z-2">
        <div class="">  
           <ul class="nav mb-2 mb-lg-0">
                <li class="nav-item nav-text fs-7 mt-2">
                    <a href="tel:8333763766" class="nav-link link-light">
                       (833-376-3766) 
                    </a>
                </li>
            </ul>
        </div>
        <div class="">
            <ul class="nav mb-2 mb-lg-0">
                <li class="nav-item fs-7 mt-2">
                    <a href="https://portal.fhadvantage.com" class="nav-link link-light">
                        Login
                    </a>
                </li>

            </ul>
        </div>
    </nav>
</div>
<nav class="navbar navbar-expand-lg navbar-dark bg-black z-1 d-none d-lg-flex">
    <div class="container z-1 ">
        <ul class="navbar-nav d-none d-lg-flex mt-3">
            <li class="nav-item">
                <a class="nav-link text-light" routerLink="/patients" routerLinkActive="active-link">Patients</a>
            </li>
            <li class="nav-item">
                <a class="nav-link text-light" routerLink="/providers" routerLinkActive="active-link">Providers</a>
            </li>
        </ul>

        <div class="d-flex flex-column justify-content-center ">
            <a class="navbar-brand fs-1 mx-auto" href="#"  [class.home]="router.url === '/'">
                <img src="assets/icons/Asset 1@2x.png" alt="Family Health Advantage logo"/>
            </a>
            <h1 class="display-2 box-heading text-center" [class.home]="router.url === '/'">Family Health Advantage</h1>
        </div>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon text-white"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-between flex-grow-0 mt-3" id="navbarSupportedContent">
            <ul class="navbar-nav me-0">
                <li class="nav-item">
                    <a class="nav-link text-light" routerLink="/find-a-provider" routerLinkActive="active-link">Find a Provider</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-light" routerLink="/contact" routerLinkActive="active-link">Contact</a>
                </li>
            </ul>
        </div>
    </div>
  </nav>
  <nav class="navbar navbar-dark bg-black d-flex d-lg-none">
    <div class="container-fluid">
        <a class="navbar-brand" href="#">FHAdvantage</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link text-light" routerLink="/patients" routerLinkActive="active-link">Patients</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-light" routerLink="/providers" routerLinkActive="active-link">Providers</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-light" routerLink="/find-a-provider" routerLinkActive="active-link">Find a Provider</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-light" routerLink="/contact" routerLinkActive="active-link">Contact</a>
                </li>
                <li class="nav-item">
                    <a href="https://portal.fhadvantage.com" class="nav-link link-light">
                        Login
                    </a>
                </li>
            </ul>
        </div>
    </div>        
  </nav>